import React, { Component } from 'react'
import { Set } from 'immutable'
import PropTypes from 'prop-types'

type SelectableValueType = string | null | undefined

interface State {
  values: Set<SelectableValueType>
}

interface Props {
  defaultValues?: Set<SelectableValueType>
  multiple?: boolean
  name: string
  noCollapse?: boolean
  onChange?: (event?: React.ChangeEvent<any>) => void
  onSelect?: (nextState: Set<SelectableValueType>, value: SelectableValueType) => void
  onValid?: () => void
  onInvalid?: () => void
}

class Group extends Component<Props, State> {
  public static childContextTypes = {
    handleChange: PropTypes.func,
    multiple: PropTypes.bool,
    name: PropTypes.string,
    noCollapse: PropTypes.bool,
    values: PropTypes.object
  }

  constructor(props: Props) {
    super(props)

    this.state = {
      values: props.defaultValues || Set()
    }

    this.handleChange = this.handleChange.bind(this)

    this.handleGroupValidate()
  }

  public handleGroupValidate() {
    const { onValid, onInvalid } = this.props
    const isValid = this.state.values.size > 0

    if (isValid && onValid) {
      onValid()
    } else if (onInvalid) {
      onInvalid()
    }
  }

  public handleChange(value: SelectableValueType) {
    this.setState((prevState, props) => {
      let nextState

      if (props.multiple) {
        nextState = prevState.values.includes(value)
          ? prevState.values.delete(value)
          : prevState.values.add(value)
      } else {
        nextState = Set([value])
      }

      if (this.props.onSelect) {
        this.props.onSelect(nextState, value)
      }

      return { values: nextState }
    }, this.handleGroupValidate)

    if (this.props.onChange) {
      this.props.onChange()
    }
  }

  public getChildContext() {
    return {
      handleChange: (value: SelectableValueType) => this.handleChange(value),
      multiple: this.props.multiple,
      name: this.props.name,
      noCollapse: this.props.noCollapse,
      values: this.state.values
    }
  }

  public render() {
    return this.props.children
  }
}

export default Group

export { SelectableValueType }
